module.exports = __webpack_public_path__ + "img/0Q3A6952_FoamcoreMatted.effbb037.jpg";